<template>

  <div class="wrapper">
    <div class="animated fadeIn">
      <h1 slot="title" class="mt-2 text-uppercase text-left font-weight-bold">Palletizaje</h1>
      <b-row>
        <b-col cols="12">
          <div className="animated">
            <b-card no-body>
            <form-wizard
              color="#0074d9"
              shape="circle"
              stepSize="sm"
              errorColor="#ff4136"
              ref="wizard"
              nextButtonText="Siguiente"
              backButtonText="Atrás"
              finishButtonText="Finalizar"
              @on-complete="onComplete(waybillData.id)"
              title=""
              subtitle=""
            >
                <tab-content class="animated fadeIn" title="Datos Proceso" :before-change="submitForm">

                  <RepaletizajeForm
                  :processData="processData"
                  ref="RepaletizajeForm"
                  >
                  </RepaletizajeForm>

                </tab-content>

                <tab-content class="animated fadeIn" title="Repaletizaje" :before-change="EndRepaletizaje">
                  

                    <RepaletizajeForm2
                  :processData="processData"
                  ref="RepaletizajeForm2"
                  >
                  </RepaletizajeForm2>

                </tab-content>

                <tab-content class="animated fadeIn" title="Detalle Repaletizaje" :before-change="tapTerminar">
       
                  <component :is="componenteActual" :process="tableDataPalletIn" :tableDataMovimientos="tableDataMovimientos"  ref="ReportRepaletizaje"></component>

                </tab-content>
                
             
              </form-wizard>
                
            </b-card>
          </div>
        </b-col>
      </b-row>



     <!-- Modal terminar Proceso-->
    <b-modal
         id="ModalTerminarProceso"
      title="Terminar proceso"
      size="sm"
      class="modal-primary"
      v-model="modalShown"
      hide-footer
    >

    
      <b-form @submit.prevent="onSubmitTerminarProceso">
        <b-form-group >

            <template v-if="editProcess == false">

          <label >
            Ingrese fecha fin de proceso
             </label>

          <datetime
            type="datetime"
            :state="$v.inputFechaTermino.$dirty ? !$v.inputFechaTermino.$error : null"
            v-model="$v.inputFechaTermino.$model"
            required
            :minute-step="10"
            aria-describedby="input-inputFechaTermino-live-feedback"
            input-class="form-control"
            class="theme-orange">
          </datetime>

  

          <b-form-invalid-feedback id="input-inputFechaTermino-live-feedback">
            Fecha es requerido
          </b-form-invalid-feedback>

          </label>

          </template>

          <template v-if="editProcess == true">

           </template>

          

        </b-form-group>

        <b-button type="submit" variant="primary">Terminar</b-button>
        
      </b-form>
    </b-modal>






    </div>
  </div>

</template>


<script>


  import moment from 'moment';
  import numeral from 'numeral';
  import locales from 'numeral/locales'
  import RepaletizajeForm from './RepaletizajeForm'
  import RepaletizajeForm2 from './RepaletizajeForm2'
  import ReportRepaletizaje from './ImprimirRepaletizaje.vue'

  import {
    required,
    numeric,
    minLength,
    between
  }


    from "vuelidate/lib/validators";

  numeral.locale('es');

  var d = new Date();

  export default {
    name: 'inicio',
    components: {
      RepaletizajeForm,
      RepaletizajeForm2,
      ReportRepaletizaje,
    },
    mounted() {
      this.getTipoProcesos();
    },
    data() {
      return {
        processtype: [],
        inputFechaTermino: '',
        modalShown: false,
        editProcess: false,
        componenteActual: '',
        tableDataPalletIn: [],
        tableDataMovimientos:[],
        processData: {
          id: null,
          number: null,
          start_time: null,
          end_time: null,
          process_type: null,
          shift: "",
          shift_workers: null,
          shift_supervisor: "",
          note: null,
          material_waybill: null,
          plant: "",
          origin: null,
          process_room: null,
          variety: '',
          product: null,
          condition: '',
          company: '',
          client_customer: ""
        },
      }
    },
    computed: {},
    validations: {
      inputFechaTermino: {
        required
      }

    },
    methods: {
      submitForm() {

        if (this.processData.id != null) {

          var formValidacion = this.$refs.RepaletizajeForm.updateProcess();
    
          if (formValidacion == 0) {

            this.$swal.fire(
              "Campos requeridos o invalidos en el formulario",
              "",
              "warning"
            );

            return false;

          } else {

            return true;
          }


        } else {
          
          var formValidacion = this.$refs.RepaletizajeForm.saveForm();
        
          if (formValidacion == 0) {

            this.$swal.fire(
              "Campos requeridos o invalidos en el formulario",
              "",
              "warning"
            );

            return false;

          } else {

            return true;
          }


        }


      },
      EndRepaletizaje() {

         this.componenteActual='ReportRepaletizaje';
          this.getProcessRepa(this.processData.id);
    
        return true;


      },
       getProcessRepa (process_id) {
        
            this.tableDataPalletIn=[];
           this.tableDataMovimientos=[];

          this.$axios.get ('/api/v1/process/'+process_id+'/process_detail_repaletizaje/')
          .then(res => {
              this.tableDataPalletIn = res.data.movement_content;
              this.loading = false;

            const datos = res.data.movement_content;


            for (let key in datos) {

              var rowNew = {
                Pallet_entrada: datos[key].content.pallet_number,
                Pallet_salida: datos[key].content_reference.pallet_number,
                Producto: datos[key].content.product_name,
                Tipo_producto: datos[key].content.product_type_name,
                Variedad: datos[key].content.variety_name,
                origin: datos[key].content_reference.origin_name,
                kilos_brutos: datos[key].content.gross_kilograms,
                kilos_netos: datos[key].content.net_kilograms,
                Cantidad: datos[key].content.quantity,
                IDContenido: datos[key].content.id,
                container: datos[key].content_reference.container.name,
                condition: datos[key].content_reference.condition,
                variety: datos[key].content_reference.variety_name,
                creation_date: datos[key].content_reference.creation_date,
                plant: datos[key].content_reference.plant,

              };

              this.tableDataMovimientos.push(rowNew);
            }
          })
          .catch(error => console.log(error.message))
        },
      gotoFormTipoProceso(url, idtipoproceso, tipoprocesotexto) {


        this.$router.push('/proceso/' + url + '/' + idtipoproceso);
      },
      getTipoProcesos() {

        this.$axios.get('/api/v1/processtype/')
          .then(res => {
            this.processtype = res.data
          })
          .catch(error => console.log(errors))


      }, onSubmitTerminarProceso() {

        const formData = {
          id: this.processData.id,
          end_time: this.inputFechaTermino,
          edit_process: this.editProcess,
          client: this.$store.getters.user.ID_CLIENTE
        };

        this.$axios.put('/api/v1/process/finish_process/', formData)
          .then(res => {

            this.modalShown = false;

            if (res.data.status == 1) {

              this.$swal.fire(
                "Proceso concluido con éxito",
                "",
                "success"
              );

             this.$router.push("/procesos/listado");

              return true;


            } else {

              this.$swal.fire(
                "Problemas al terminar proceso",
                "",
                "error"
              );

              return false;

            }

          })
          .catch(error => console.log(error))


      }, tapTerminar() {

        this.modalShown = true;

        // this.$swal
        //   .fire({
        //     title: "Seguro que quieres terminar este despacho?",
        //     text: "",
        //     type: "warning",
        //     showCancelButton: true,
        //     confirmButtonColor: "#3085d6",
        //     cancelButtonColor: "#d33",
        //     cancelButtonText: "No",
        //     confirmButtonText: "SI"
        //   })
        //   .then(result => {

        //     if (result.value) {

        //       this.$swal.fire("Repaletizaje concluido con exito", "", "success");
        //       this.$router.push("/");

        //       return true;
        //     }
        //   });

        // return false;
      }


    },

    beforeMount() {

    },

  }
</script>
